import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MessageService 
{
	private httpRequestStartedSource = new Subject<string>()
	private httpRequestCompletedSource = new Subject<string>()
	private loginSessionExpiredSource = new Subject<void>()
	private preferredLanguageChangedSource = new Subject<void>()

  	httpRequestStarted$ = this.httpRequestStartedSource.asObservable()
	httpRequestCompleted$ = this.httpRequestCompletedSource.asObservable()
	loginSessionExpired$ = this.loginSessionExpiredSource.asObservable()
	preferredLanguageChanged$ = this.preferredLanguageChangedSource.asObservable()

  	startedHttpRequest(route: string)
	{
		this.httpRequestStartedSource.next(route)
	}

	completedHttpRequest(route: string)
	{
		this.httpRequestCompletedSource.next(route)
	}

	loginSessionExpired()
	{
		this.loginSessionExpiredSource.next()
	}

	preferredLanguageChanged()
	{
		this.preferredLanguageChangedSource.next()
	}
}
